<div>
    <ng-container *ngIf="!isConfirm">
        <div class="header-container">
            <!-- <div class = "header5 overview">Overview</div> -->
            <div class="icon"><img src="/assets/icons/x-circle.svg" alt="close" (click)="close()"></div>
        </div>
        <div class="container">
            <span class="header3">{{data.name}}</span>
            <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            <div class="table-container" *ngIf="tableData && tableData.length > 0">
                <table *ngIf="userType === 'dealeradmin'" mat-table [dataSource]="tableData" matSort>
                    <ng-container matColumnDef="country">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="header8"> Country </th>
                        <td mat-cell *matCellDef="let tableData" class="column"> {{tableData.country}} </td>
                    </ng-container>

                    <ng-container matColumnDef="schedule">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header class="header8"> Display Schedule </th>
                        <td mat-cell *matCellDef="let tableData" class="column"> {{formatTimeFrame(tableData.schedule)}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="manage">
                        <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                        <mat-cell *matCellDef="let tableData">
                            <img src="assets/icons/more-vertical.svg" class="table-icon" [matMenuTriggerFor]="menu"
                                id="manageOptions">
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item (click)="clickEdit(tableData.schedule)">
                                    <i-feather class="icon" name="Edit2">
                                    </i-feather>
                                    Edit
                                </button>
                                <button mat-menu-item color="warn" (click)="confirmOn(tableData.insightAccessGuid)">
                                    <i-feather class="icon delete" color="red" name="Trash2"></i-feather><span
                                        style="color:red">Delete</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayColumns;" [class.data-selected]="row.isSelected">
                    </tr>
                </table>
            </div>
            <div class="button-container">
                <button mat-raised-button (click)="close()">Close</button>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="isConfirm">
        <div class="confirm-container">
            <div class="des">
                Are you sure you want to delete this scheduled group from viewing <span
                    class="header4">{{data.name}}</span>?
                Deleting this row will remove it from being scheduled permanently.
            </div>
            <div class="btn-container">
                <button mat-button (click)="goBack()">Go Back</button>
                <button mat-stroked-button color="warn" (click)="delete(deleteId)">
                    <i-feather class="icon" name="Trash2"></i-feather>Yes, Delete
                </button>
            </div>
        </div>
    </ng-container>
</div>